module.exports = __webpack_public_path__ + "static/media/2002_GDP_totalRate.5de6cf03.png";